import React, { createContext, useState, useMemo } from "react";
import { FLOW_CONFIGURATION_ERROR, FLOW_MODE, } from "../constants";
export var MainContext = createContext({
    lang: "es",
    idLogo: null,
    token: null,
    apiKey: null,
    flowMode: FLOW_MODE.LIVENESS,
    enrollmentId: null,
    flowConfigurationError: null,
    tracking: "auto",
    setApiKey: function () { },
    setTracking: function () { },
    environment: null,
    accessToken: null,
    getFromUrl: function () { },
});
export var MainProvider = function (_a) {
    var children = _a.children;
    var _b = useState("es"), lang = _b[0], setLang = _b[1];
    var _c = useState(null), idLogo = _c[0], setIdLogo = _c[1];
    var _d = useState(null), token = _d[0], setToken = _d[1];
    var _e = useState(null), apiKey = _e[0], setApiKey = _e[1];
    var _f = useState(null), environment = _f[0], setEnviroment = _f[1];
    var _g = useState(null), accessToken = _g[0], setAccessToken = _g[1];
    var _h = useState(false), leyend = _h[0], setLeyend = _h[1];
    var _j = useState("auto"), tracking = _j[0], setTracking = _j[1];
    var _k = useState(FLOW_MODE.LIVENESS), flowMode = _k[0], setFlowMode = _k[1];
    var _l = useState(null), enrollmentId = _l[0], setEnrollmentId = _l[1];
    var _m = useState(null), flowConfigurationError = _m[0], setFlowConfigurationError = _m[1];
    var getFromUrl = function (location) {
        var params = new URLSearchParams(location.search);
        var isEnrollment = params.get("enrollment") === "true";
        var isAuth = params.get("auth") === "true";
        var enrollmentIdentifier = params.get("enrollmentId");
        var selectedMode = FLOW_MODE.LIVENESS;
        var modeError = null;
        if (isEnrollment && isAuth) {
            modeError = FLOW_CONFIGURATION_ERROR.MUTUALLY_EXCLUSIVE_MODES;
        }
        else if (isEnrollment) {
            selectedMode = FLOW_MODE.ENROLLMENT;
        }
        else if (isAuth) {
            selectedMode = FLOW_MODE.AUTH_3D;
        }
        if ((selectedMode === FLOW_MODE.ENROLLMENT || selectedMode === FLOW_MODE.AUTH_3D) &&
            !enrollmentIdentifier) {
            modeError = FLOW_CONFIGURATION_ERROR.MISSING_ENROLLMENT_ID;
        }
        setLang(params.get("lang"));
        setIdLogo(params.get("logo"));
        setToken(params.get("token"));
        setApiKey(params.get("apikey"));
        setEnviroment(params.get("env"));
        setAccessToken(params.get("accesstoken"));
        setLeyend(params.get("leyend"));
        var selfTranking = params.get("tracking") || "auto";
        setTracking(selfTranking);
        setFlowMode(selectedMode);
        setEnrollmentId(enrollmentIdentifier);
        setFlowConfigurationError(modeError);
        return {
            lang: params.get("lang") || lang,
            idLogo: params.get("logo"),
            token: params.get("token"),
            apiKey: params.get("apikey"),
            environment: params.get("env"),
            accessToken: params.get("accesstoken"),
            margin: params.get("margin"),
            leyend: params.get("leyend"),
            tracking: params.get("tracking"),
            flowMode: selectedMode,
            enrollmentId: enrollmentIdentifier,
            flowConfigurationError: modeError,
        };
    };
    var value = useMemo(function () {
        return {
            lang: lang,
            idLogo: idLogo,
            token: token,
            apiKey: apiKey,
            environment: environment,
            accessToken: accessToken,
            flowMode: flowMode,
            enrollmentId: enrollmentId,
            flowConfigurationError: flowConfigurationError,
            setApiKey: setApiKey,
            getFromUrl: getFromUrl,
            leyend: leyend,
            tracking: tracking,
        };
    }, [
        lang,
        idLogo,
        token,
        apiKey,
        environment,
        accessToken,
        flowMode,
        enrollmentId,
        flowConfigurationError,
        setApiKey,
        tracking,
        getFromUrl,
    ]);
    return React.createElement(MainContext.Provider, { value: value }, children);
};
